import type { ReactNode } from "react";

export function MetadataElementLayout({ fields }: { fields: { key: string; content: ReactNode }[] }) {
  const placementKeys = ["position", "offset", "origin", "rotation", "scale", "size", "x", "y", "opacity"];
  const placementKeysSet = new Set(placementKeys);
  const placementFields = fields.filter(field => placementKeysSet.has(field.key));
  const otherFields = fields.filter(field => !placementKeysSet.has(field.key));
  return (
    <div className="space-y-3">
      {placementFields.length > 0 && (
        <div data-placement-group className="flex w-full overflow-hidden rounded-lg border border-neutral-200 bg-white [&>div:not(:last-child)_[data-placement-field]]:border-r">
          {placementFields.map(field => (
            <div key={field.key} className="contents">
              {field.content}
            </div>
          ))}
        </div>
      )}
      {otherFields.length > 0 && <div className="divide-y divide-neutral-200 overflow-hidden rounded-lg border border-neutral-200 bg-neutral-50 [&>div>[data-slot=collapsible]]:rounded-none [&>div>[data-slot=collapsible]]:border-0">
        {otherFields.map(field => <div key={field.key}>{field.content}</div>)}
      </div>}
    </div>
  );
}
